import { render, staticRenderFns } from "./oilCardDivJoin.vue?vue&type=template&id=2b75121f&scoped=true&"
import script from "./oilCardDivJoin.vue?vue&type=script&lang=js&"
export * from "./oilCardDivJoin.vue?vue&type=script&lang=js&"
import style0 from "./oilCardDivJoin.vue?vue&type=style&index=0&id=2b75121f&scoped=true&lang=css&"
import style1 from "./oilCardDivJoin.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b75121f",
  null
  
)

export default component.exports